import React from 'react'
import RadioFormGroup from 'redesign/components/molecules/RadioFormGroup'
import { useAbsencePeriodSelection } from './hooks/use-absence-period-selection'
import type { AbsencePeriodSelectionProps } from './types'

const AbsencePeriodSelection: React.FC<AbsencePeriodSelectionProps> = ({ formFields, formErrors, setValue }) => {
  const { absencePeriodError, displayAbsencePeriodDuration, options, selectedValue, setSelectedValue, t } =
    useAbsencePeriodSelection({
      formFields,
      formErrors,
      setValue,
    })

  return displayAbsencePeriodDuration ? (
    <RadioFormGroup
      error={Boolean(absencePeriodError)}
      legend={t('absencePeriod.label')}
      options={options}
      setSelectedValue={setSelectedValue}
      selectedValue={selectedValue}
    />
  ) : null
}

export default AbsencePeriodSelection
